/* global __DEV__ */

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import createHelpers from './createHelpers';
import createLogger from './logger';

const APP = __APP__;

const noOp = x => x;

export default function configureStore(initialState, rootReducer, helpersConfig) {
  const helpers = createHelpers(helpersConfig);
  const middleware = [thunk.withExtraArgument(helpers)];

  let enhancer = process.env.BROWSER
    ? persistState(['advertForm', 'partsForm', 'user'], {
        slicer: () => ({ advertForm, partsForm, user }) => ({
          advertForm: {
            selected: {
              ...advertForm.selected,
              photos: [],
            },
            data: {
              newExistingPhotos: advertForm.data.newExistingPhotos
                ? [...advertForm.data.newExistingPhotos]
                : [],
              currentFormStep: user && user.token ? advertForm.data.currentFormStep : '',
            },
          },
          user: {
            token: user.token,
            user: user.user,
            error: user.error,
            balance: user.balance,
          },
          partsForm:
            !partsForm || partsForm.isEdit
              ? {}
              : {
                  ...partsForm,
                  selected: {
                    ...partsForm.selected,
                    photos: [],
                  },
                },
        }),
      })
    : noOp;

  if (__DEV__) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    let devToolsExtension = noOp;
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(enhancer, applyMiddleware(...middleware), devToolsExtension);
  } else {
    enhancer = compose(enhancer, applyMiddleware(...middleware));
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(
    rootReducer,
    initialState,
    enhancer,
    typeof window === 'object' &&
      window._REDUX_DEVTOOLS_EXTENSION_ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept(`../../${APP}/reducers`, () =>
      // eslint-disable-next-line global-require, import/no-dynamic-require
      store.replaceReducer(require(`../../${APP}/reducers/index`).default),
    );
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/shared/store/configureStore.js